export default __webpack_public_path__ + "static/handynavigation-91fc394574095530870a49035a74a401.jpg";